import moment from 'moment'
import Hammer from 'hammerjs'
import Helpers from '../modules/Helpers'


class CalendarRange {
    constructor(container, changeEvent = () => { }) {
        this.container = container

        this.getControls()
        this.getParameters()
        this.changeEvent = changeEvent

        this.listeners()
        this.hammer()
        this.render()
    }

    getControls() {
        this.prevButtonContainer = this.container.getElementsByClassName('calendar-range__container--left')[0]
        this.nextButtonContainer = this.container.getElementsByClassName('calendar-range__container--right')[0]
        this.prevButton = this.container.getElementsByClassName('calendar-range__move--left')[0]
        this.nextButton = this.container.getElementsByClassName('calendar-range__move--right')[0]
        this.monthContainer = this.container.getElementsByClassName('calendar-range__months')[0]
    }

    getParameters() {
        this.minCalendarWidth = 240
        this.minDate = moment(this.container.getAttribute('data-minDate'), "YYYY-MM-DD")
        this.maxDate = moment(this.container.getAttribute('data-maxDate'), "YYYY-MM-DD")
        this.currentMonth = moment(this.minDate).startOf('month')
        this.noOfCalendars = null

        this.selectedStart = null
        this.selectedEnd = null
        
        return this
    }

    listeners() {
        new Helpers(this.prevButtonContainer).eventListener((e) => {
            e.preventDefault()
            this.move('prev')
        })

        new Helpers(this.nextButtonContainer).eventListener((e) => {
            e.preventDefault()
            this.move('next')            
        })
    }

    move(direction) {
        if (direction === 'next') {
            if (moment(this.currentMonth).endOf('month').isBefore(this.maxDate)) {
                this.currentMonth.add(1, 'month')
                this.render()
            }
        } else {
            if (moment(this.currentMonth).startOf('month').isAfter(this.minDate)) {
                this.currentMonth.subtract(1, 'month')
                this.render()
            }
        }
    }

    /**
     * Instantiate Hammer.js
     * 
     * @return {Object}
     */
    hammer() {
        if (typeof Hammer === 'function') {
            const hammertime = new Hammer(this.container)

            hammertime.on('swipeleft swiperight', (e) => {
                let direction = ''
                if (e.type == 'swiperight') {
                    direction = 'prev'
                } else {
                    direction = 'next'
                }
                this.lastMoveTime = (new Date).getTime();
                this.move(direction)
            })
        }

        return this
    }

    setNoOfCalendars(calendars) {
        this.noOfCalendars = calendars

        return this;
    }

    visibleMonths() {
        return this.noOfCalendars || Math.max(Math.floor(this.container.offsetWidth / this.minCalendarWidth), 1)
    }

    render() {
        // clear container
        this.monthContainer.innerHTML = ''

        for (let i = 0; i <= this.visibleMonths()-1; i++) {
            const monthStart = moment(this.currentMonth).add(i, 'month').startOf('month')
            const monthEnd = moment(monthStart).endOf('month')
            // wrapper div
            const wrap = document.createElement('div')
            new Helpers(wrap).addClass('calendar-range__month')
            // month title
            const title = document.createElement('h4')
            title.innerText = monthStart.format("MMMM YYYY")
            wrap.appendChild(title)

            // table
            const table = document.createElement('table')

            //day headers
            const header = document.createElement('tr');

            ['M', 'T', 'W', 'T', 'F', 'S', 'S'].forEach((d) => {
                const day = document.createElement('th')
                day.innerText = d
                header.appendChild(day)
            })
            table.appendChild(header)

            // days of the month
            const calendarStart = moment(monthStart).startOf('isoweek')
            const calendarEnd = moment(monthEnd).endOf('isoweek')

            let count = 0
            for (let row = 0; row < 6; row++) {
                // rows
                const tr = document.createElement('tr')

                for (let col = 0; col < 7; col++) {
                    // days
                    const calendarDay = moment(calendarStart).add(count,'day')
                    if (calendarDay.isAfter(calendarEnd)) {
                        continue;
                    }
                    const td = document.createElement('td')
                    new Helpers(td).addClass('calendar-range__day')

                    // check if the day is within the month
                    if (calendarDay.isBefore(monthStart) || calendarDay.isAfter(monthEnd)) {
                        new Helpers(td).addClass('calendar-range__day--adjoining')
                    } else {
                        td.innerText = calendarDay.date()
                        td.id = calendarDay.format("YYYY-MM-DD")
                        if (calendarDay.isBefore(this.minDate) || calendarDay.isAfter(this.maxDate)) {
                            new Helpers(td).addClass('calendar-range__day--inactive')
                        }
                    }

                    tr.appendChild(td)
                    count += 1
                }
                if (tr.innerHTML.length>0) {
                   table.appendChild(tr)
                }
            }
            wrap.appendChild(table)
            this.monthContainer.appendChild(wrap)
        }

        //toggle visiblity of nav buttons
        this.prevButton.disabled = this.currentMonth.isSame(this.minDate, 'month')
        this.nextButton.disabled = moment(this.currentMonth).add(this.visibleMonths()-1,'month').isSame(this.maxDate, 'month')

        this.highlightRange(this.selectedStart, this.selectedEnd,false)

        this.calendarListeners()

        return this
    }

    calendarListeners() {
        new Helpers(document.getElementsByClassName('calendar-range__day')).eventListener((e) => {
            this.hoverAction(e.currentTarget)
        }, 'mouseover')

        new Helpers(document.getElementsByClassName('calendar-range__months')).eventListener((e) => {
            this.clearHighlight()
        }, 'mouseout')

        new Helpers(document.getElementsByClassName('calendar-range__day')).eventListener((e) => {
            if ((this.lastMoveTime || 0) < (new Date).getTime() - 500) {
                this.clickAction(e.currentTarget)
            }
        })
    }

    hoverAction(cell) {
        const el = new Helpers(cell)
        if (this.selectedStart == null) {
            if (el.hasClass('calendar-range__day--inactive') || el.hasClass('calendar-range__day--adjoining')) {
                this.clearHighlight()
            } else {
                this.highlightRange(this.cellDate(cell), null, true)
            }
        } else if (this.selectedEnd === null) {
            // end hover
            if (el.hasClass('calendar-range__day--inactive') || el.hasClass('calendar-range__day--adjoining')) {
                this.clearHighlight();
            } else {
                this.highlightRange(this.selectedStart, this.cellDate(cell), true)
            }
        }
    }

    clickAction(cell) {
        const el = new Helpers(cell)

        if (this.selectedStart === null) {
            // start
            if (!el.hasClass('calendar-range__day--inactive') && !el.hasClass('calendar-range__day--adjoining')) {
                this.selectedStart = this.cellDate(cell)
            }
        } else if (this.selectedEnd === null) {
            // end 
            if (!el.hasClass('calendar-range__day--inactive') && !el.hasClass('calendar-range__day--adjoining')) {
                this.selectedEnd = this.cellDate(cell)
                if (this.selectedEnd.isBefore(this.selectedStart)) {
                    // if the dates are invalid, clear
                    this.clearSelected()
                    this.selectedStart = null
                    this.selectedEnd = null
                }
            }
        } else {
            this.clearSelected()
            this.selectedStart = this.cellDate(cell)
            this.selectedEnd = null
        }

        this.highlightRange(this.selectedStart, this.selectedEnd, false)

        this.changeEvent(this.selectedStart,this.selectedEnd)
    }

    setDates(startDate, endDate) {
        this.clearHighlight()
        this.clearSelected()
        this.selectedStart = startDate
        this.selectedEnd = endDate
        this.highlightRange(this.selectedStart, this.selectedEnd, false)
    }

    cellDate(cell) {
        return moment(cell.id, 'YYYY-MM-DD')
    }

    clearHighlight() {
        // reset hover UI
        new Helpers(document.getElementsByClassName('calendar-range__day')).removeClass('calendar-range__day--highlight')
    }

    clearSelected() {
        new Helpers(document.getElementsByClassName('calendar-range__day')).removeClass('calendar-range__day--selected')
    }

    highlightRange(startDate, endDate, hover = true) {
        this.clearHighlight()

        if (startDate === null && endDate === null) {
            return;
        }

        if (endDate === null) {
            endDate = startDate
        }

        // first cell
        let d = new moment(startDate)
        while (d.isBefore(endDate) || d.isSame(endDate)) {
            const cellId = d.format("YYYY-MM-DD")
            const cell = document.getElementById(cellId)
            if (cell !== null) {
                const start = moment(d).isSame(startDate)
                const end = moment(d).isSame(endDate)

                if (hover) {
                    new Helpers(cell).addClass('calendar-range__day--highlight')
                } else {
                    new Helpers(cell).addClass('calendar-range__day--selected')
                }
            }
            // move to the next day
            d.add(1,'day')
        }
    }
}

export default CalendarRange